/**
 * loadToken.js
 * Written by: Alex Kasemir
 */

import { checkExpiredToken } from '../checkExpiredToken';

/**
 * Description of the loadToken action
 */
export const loadToken = (jwtToken) => {
  return async (dispatch) => {
    if (jwtToken) {
      try {
        await dispatch(checkExpiredToken(jwtToken));
      } catch (e) {
        throw e;
      }
    } else {
      throw new Error(`No jwtToken provided`);
    }
  };
};

export default loadToken;
